
import React, { useState, Suspense } from 'react';
import OptimizedSplashscreen from '../components/optimized/OptimizedSplashscreen';
import { CriticalCSS } from '../components/optimized/CriticalCSS';
import { PerformanceMonitor } from '../components/performance/PerformanceMonitor';

// Lazy loading des composants non-critiques
const Header = React.lazy(() => import('../components/Header'));
const Hero = React.lazy(() => import('../components/Hero'));
const About = React.lazy(() => import('../components/About'));
const Services = React.lazy(() => import('../components/Services'));
const Contact = React.lazy(() => import('../components/Contact'));
const Footer = React.lazy(() => import('../components/Footer'));
const WhatsAppButton = React.lazy(() => import('../components/WhatsAppButton'));

const Index = () => {
  const [showSplash, setShowSplash] = useState(true);

  const handleSplashComplete = () => {
    setShowSplash(false);
  };

  if (showSplash) {
    return <OptimizedSplashscreen onComplete={handleSplashComplete} />;
  }

  return (
    <div className="min-h-screen bg-white font-inter">
      <CriticalCSS />
      <PerformanceMonitor />
      
      <Suspense fallback={
        <div className="flex items-center justify-center min-h-screen">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-pink-600"></div>
        </div>
      }>
        <Header />
        <Hero />
        <About />
        <Services />
        <Contact />
        <Footer />
        <WhatsAppButton />
      </Suspense>
    </div>
  );
};

export default Index;
